module.exports = __webpack_public_path__ + "img/register.d9d99d30.png";